<template>
  <div class="plat-form-wrap">
    <div class="slides-wrap">
      <a-carousel arrows>
        <div
          class="dot-item"
          :style="{ backgroundImage: `url(${bgImg})` }"
        ></div>
      </a-carousel>
    </div>
    <div class="body-wrap home-mini-width">
      <div class="intelligencematch-search searchCard">
        <div class="searchClass">
          <InputSearch
            placeholder="输入需求名称"
            btnTitle="搜索"
            @search="handleSearch"
            :isBtn="true"
            :addonBefore="addonBefore"
          />
        </div>
      </div>
      <div class="intelligencematch-content">
        <MatchDisplay :demandList="demandList"></MatchDisplay>
      </div>
    </div>
  </div>
</template>

<script>
import InputSearch from '@/components/InputSearch/index.vue'
import MatchDisplay from './components/matchDisplay.vue'
import { getIntelligenceMatch } from '@/api/IntelligenceMatch.js'

export default {
  data() {
    return {
      bgImg: require('@/assets/images/patentImg/banner2.png'),
      addonBefore: '需求分析',
      demandList: []
    }
  },
  components: {
    // Search,
    InputSearch,
    MatchDisplay
  },
  created() {
    // this.handleSearch('')
  },
  methods: {
    async handleSearch(v) {
      if (v) {
        const params = { name: v }
        const res = await getIntelligenceMatch(params)
        if (res.data.length === 0) {
          this.$message.success('搜索的内容没有匹配的内容,请重新输入!')
          return
        }
        this.demandList = res.data
      } else {
        this.demandList = []
      }
    }
  }
}
</script>
